if (!customElements.get('redd-discount-offer')) {
  customElements.define('redd-discount-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-discount-open]');
      this.copyButton = this.querySelector('[data-discount-copy]');
      this.copyLabel = this.querySelector('[data-discount-copy-label]');
      this.code = this.querySelector('[data-discount-code]');
      this.status = this.querySelector('[data-discount-status]');
      if (!this.dialog || !this.trigger || !this.copyButton || !this.code || typeof this.dialog.showModal !== 'function') return;
      this.defaultLabel = this.copyLabel.textContent;
      this.requestId = 0;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger.addEventListener('click', () => {
        this.resetCopy();
        this.dialog.showModal();
      }, options);
      this.querySelector('[data-discount-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.resetCopy();
        this.trigger.focus({ preventScroll: true });
      }, options);
      this.copyButton.addEventListener('click', () => this.copyCode(), options);
      this.code.addEventListener('click', () => this.code.select(), options);
      this.trigger.hidden = false;
    }

    resetCopy() {
      this.requestId += 1;
      this.copyButton.disabled = false;
      this.copyLabel.textContent = this.defaultLabel;
      this.status.textContent = '';
    }

    async copyCode() {
      const requestId = ++this.requestId;
      this.copyButton.disabled = true;
      try {
        await navigator.clipboard.writeText(this.code.value);
        if (requestId !== this.requestId || !this.dialog.open) return;
        this.copyLabel.textContent = this.dataset.copied;
        this.status.textContent = this.dataset.copied;
      } catch {
        if (requestId !== this.requestId || !this.dialog.open) return;
        this.code.focus({ preventScroll: true });
        this.code.select();
        this.status.textContent = this.dataset.copyFailed;
      } finally {
        if (requestId === this.requestId) this.copyButton.disabled = false;
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.requestId += 1;
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
